module.exports = __webpack_public_path__ + "img/index_bg.5ad9f802.png";